<!-- 小程序分享页面 -->
<template>
  <div class="AppletShareDevice">
    <van-nav-bar
      class="NavBar"
      fixed
      :border='false'
      :title="$route.meta.title"/>
      <div class="list">
        <img class="list-detail-bg" src="/static/images/phonePage/applet/detail_bg.png" />
        <div class="detail">

          <!-- 设备icon -->
          <div :class="['icon-box', deviceDetail.device_type_code]">
            <img class="icon" :src="deviceDetail.iconUrl" />
            <div class="num" v-if="deviceDetail.device_type_code == 'MAGICCUBE' || deviceDetail.device_type_code == 'DEPOSIT' || deviceDetail.device_type_code == 'IOTLETTERBOX'">{{deviceDetail.device_type_code == 'DEPOSIT' ? deviceDetail.device_num : ''}}{{deviceDetail.box_number}}</div>
          </div>

          <!-- 设备名称 -->
          <div class="device-name one-overflow">{{deviceDetail.device_name}}</div>

          <!-- 魔方柜显示箱格名称，门禁显示设备名称，其他显示“设备名称-箱格号” -->
          <div class="cell-name one-overflow" v-if="deviceDetail.device_type_code == 'MAGICCUBE'">{{deviceDetail.device_box_name}}</div>
          <div class="cell-name one-overflow" v-else-if="deviceDetail.device_type_code == 'ACCESS'">{{deviceDetail.device_name}}</div>
          <div class="cell-name one-overflow" v-else>{{deviceDetail.device_name}}-{{deviceDetail.box_number}}</div>

          <!-- 魔方柜显示-标签列表 -->
          <div class="tag-list" v-if="deviceDetail.device_type_code == 'MAGICCUBE'">
            <div :class="['tag', item.name == '' ? 'hide': '' ]" v-for="(item) in deviceDetail.tag" :key="item.id">{{item.name}}</div>
          </div>

          <!-- 寄存柜显示-剩余时间/次数 -->
          <div :class="['residue', deviceDetail.surplus_data == 0 ? 'timeout' : '']" v-if="deviceDetail.device_type_code == 'DEPOSIT'">
            剩余次数：
            <span>{{deviceDetail.surplus_data}}</span>
            <!-- <div class="title">{{deviceDetail.is_timeout == 1 ? '已超时' : (deviceDetail.once_box == 1 ? '剩余次数' : deviceDetail.time_type == 1 ? '剩余时间' : '到期时间')}}：</div>
          <div class="text">{{deviceDetail.surplus_data}}</div> -->
          </div>

          <!-- 信报箱显示 -->
          <div class="residue newMail" v-if="deviceDetail.device_type_code == 'IOTLETTERBOX'">
            新信件：
            <span>{{deviceDetail.letter_num}}</span>
          </div>
        </div>

        <!-- 设备地址 -->
        <img class="icon-address" src="/static/images/phonePage/applet/icon_address_02.png" />
        <div class="address one-overflow">{{deviceDetail.space_name}}</div>

        <!-- 授权时间/次数 -->
        <div class="authorArea" v-if="deviceDetail.token_ext_type == 1">
          <div class="text">授权次数：{{deviceDetail.token_count}}</div>
          <div class="text">剩余次数：{{deviceDetail.token_use_count}}</div>
        </div>
        <div class="authorArea" v-else>
          <div class="text">开始时间：{{deviceDetail.token_start_time}}</div>
          <div class="text">结束时间：{{deviceDetail.token_exp_time}}</div>
        </div>
      </div>
      <!-- 按钮开门 -->
      <div class="open" @click="shareOpen">
        <span v-if="deviceDetail.device_type_code == 'SOCKET' || deviceDetail.device_type_code == 'ELECTRICMETER'">{{deviceDetail.box_status == 1 ? '断电' : '通电'}}</span>
        <span v-else-if="deviceDetail.device_type_code == 'WATERMETER'">{{deviceDetail.box_status == 1 ? '断水' : '通水'}}</span>
        <span v-else>打开</span>
      </div>
      <div class="surrpot">由极酷物联提供技术支持 </div>
  </div>
</template>

<script>
  import { AppletApi } from '../../../../static/js/phone/phoneApi.js'
  import { vshowLoading, vhideLoading, vshowSuccess, vshowToast } from '../../../../static/js/phone/utility.js'
  import { setDeviceIcon } from '../../../../static/js/utility/utility.js'

  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)

  let vm

  export default {
    name: 'AppletShareDevice',
    components: {
    },
    data () {
      return {
        // 设备详情
        deviceDetail: {},
      }
    },
    created () {
      vm = this
    },
    mounted () {
      // console.log('tag', vm.$route)
      vm.getDeviceDetailsShare()
    },
    methods: {
      // 一键开箱
      async shareOpen() {
        let data = {
          token: vm.$route.params.shareToken
        }

        vshowLoading('正在开启设备')
        let res = await AppletApi.shareOpen(data)
        vhideLoading()
        if (res.meta.code === 200) {
          vshowSuccess('开启成功')
          // 若是寄存柜，重新获取设备详情
          // if (vm.$route.query.device_type_code == 'DEPOSIT') {
            setTimeout(function(){
              vm.getDeviceDetailsShare()
            }, 600)
          // }
        } else {
          vshowToast(res.meta.message)
        }
      },
      // 获取设备中心-设备详情
      async getDeviceDetailsShare() {
        let data = {
          box_number: vm.$route.params.box_number,
          device_no_id: vm.$route.params.device_no_id,
          device_type_code: vm.$route.params.device_type_code,
          token: vm.$route.params.shareToken
        }
        // console.log('data', data)

        vshowLoading('获取信息中')
        let res = await AppletApi.getDeviceDetailsShare(data)
        vhideLoading()
        if (res.meta.code === 200) {
          let deviceDetail = res.data
          if (deviceDetail.box) {
            deviceDetail.box_number = deviceDetail.box.box_number
            deviceDetail.box_size = deviceDetail.box.box_size
          }
          deviceDetail.iconUrl = '/static/images/icon/' + setDeviceIcon(deviceDetail.device_type_code)
          vm.deviceDetail = deviceDetail
          document.title = deviceDetail.device_type + '权限分享'
          console.log('设备详情', vm.deviceDetail )
        } else {
          vshowToast(res.meta.message)
        }
      }
    }
  }
</script>

<style lang="scss">
  .AppletShareDevice {
    width: 100%;
    height: 100vh;
    padding-top: 2.6rem;
    background-color: #f1f1f1;
    position: fixed;
    top: 0;
    left: 0;
    .NavBar {
      width: 100%;
      height: 0.88rem;
      background-color: #2d83f3;
      .van-icon {
        color: #ffffff;
        font-size: 0.38rem;
      }
      .van-nav-bar__left {
        top: 0;
        bottom: auto;
      }
      .van-nav-bar__title {
        font-size: 0.34rem;
        line-height: 0.88rem;
        color: #ffffff;
      }
    }

    /* 魔方柜箱格编码 */

    .list  .icon-box .num {
      width: 0.36rem;
      height: 0.36rem;
      text-align: center;
      font-size: 0.24rem;
      line-height: 0.36rem;
      color: #fff;
      border-radius: 50%;
      background-color: #5ca2ff;
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .list  {
      width: 5.2rem !important;
      margin: 0 auto;
      height: 5.2rem !important;
      border-radius: 0.2rem;
      text-align: center;
      background-color: #fff;
      box-shadow: 0.13rem 0.13rem 0.26 0.02rem rgba(0, 0, 0, 0.13);
      position: relative;
    }

    .list .list-detail-bg {
      width: 100%;
      height: 2.86rem;
      vertical-align: top;
    }

    .list .detail {
      width: 100%;
      height: 2.86rem;
      border-top-left-radius: 1.6rem;
      border-top-right-radius: 1.6rem;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .list .detail .icon-box {
      flex-shrink: 0;
      width: 0.9rem;
      height: 0.9rem;
      margin: 0.3rem 0 0;
      border-radius: 50%;
      position: relative;
    }

    .list .detail .icon-box .icon {
      width: 0.53rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .list .detail .device-name {
      flex-shrink: 0;
      max-width: 3.5rem;
      height: 0.35rem;
      font-size: 0.24rem;
      line-height: 0.35rem;
      margin: 0.05rem 0;
    }

    .list .detail .cell-name {
      flex-shrink: 0;
      max-width: 3.5rem;
      font-size: 0.3rem;
      line-height: 0.42rem;
    }

    .list .detail .tag-list {
      flex-shrink: 0;
      margin-top: 0.2rem;
      display: flex;
    }

    .list .detail .tag-list .tag {
      width: 1.12rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.24rem;
      border: 1px solid #fff;
      box-sizing: border-box;
      border-radius: 0.06rem;
      margin-right: 0.1rem;
    }

    /* 寄存柜剩余时间/次数 - 信报箱新信件 */

    .list .detail .residue {
      padding: 0 0.1rem;
      height: 0.36rem;
      line-height: 0.36rem;
      font-size: 0.24rem;
      margin-top: 0.15rem;
      color: #2d83f4;
      border-radius: 0.03rem;
      background-color: rgba(255, 255, 255, 0.75);
    }

    .list .detail .residue.timeout {
      color: #f95757;
    }

    .list .detail .newMail {
      width: 2.42rem;
      text-align: center;
      padding: 0;
    }

    .list .icon-address {
      width: 0.26rem;
      margin-top: 0.32rem;
      vertical-align: top;
    }

    .list .address {
      max-width: 3.5rem;
      margin: 0 auto;
      padding-top: 0.13rem;
      font-size: 0.24rem;
      line-height: 0.33rem;
      color: #9b9b9b;
    }

    .list .share {
      width: 1.36rem;
      font-size: 0.24rem;
      line-height: 0.58rem;
      color: #2d83f4;
      border: 0.02rem solid #2d83f4;
      border-radius: 0.05rem;
      box-sizing: border-box;
      position: absolute;
      top: 4.32rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      z-index: 10;
    }

    .list .authorArea {
      margin-top: 0.3rem;
      font-size: 0.24rem;
      line-height: 0.34rem;
      color: #999999;
    }

    .open {
      width: 2.2rem;
      height: 2.25rem;
      line-height: 2.25rem;
      color: #fff;
      text-align: center;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 1.4rem;
      margin: 0 auto;
      background: url(/static/images/phonePage/applet/open_bg.png) center no-repeat;
      background-size: 100% 100%;
      &:active {
        
      background: url(/static/images/phonePage/applet/open_bg_active.png) center no-repeat;
      background-size: 100% 100%;
      }
    }

    .open image {
      width: inherit;
      height: inherit;
      vertical-align: middle;
    }

    .open .open-bg {
      display: block;
    }

    .open .open-bg-active {
      display: none;
    }

    .open:active .open-bg {
      display: none;
    }

    .open:active .open-bg-active {
      display: block;
    }

    .open text {
      display: inline-block;
      font-size: 0.45rem;
      position: relative;
      top: -2.25rem;
    }

    .surrpot {
      width: 100%;
      font-size: 0.24rem;
      color: #999999;
      text-align: center;
      position: absolute;
      bottom: 0.5rem;
      left: 0;
    }
    
    /* 设备icon背景色 */
    .icon-box.MAGICCUBE {  /*魔方柜*/
      background-color: #f55151;
    }

    .icon-box.TURN {  /*周转柜*/
      background-color: #527bf3;
    }

    .icon-box.ACCESS {  /*门禁*/
      background-color: #f04f74;
    }

    .icon-box.DEPOSIT {  /*寄存柜*/
      background-color: #F97D3E;
    }

    .icon-box.TOOL {  /*工具柜*/
      background-color: #F6BE39;
    }

    .icon-box.SOCKET {  /*插座*/
      background-color: #8c70d1;
    }

    .icon-box.IOTLETTERBOX {  /*信报箱*/
      background-color: #1657b0;
    }

    .icon-box.WATERMETER {  /*智能水表*/
      background-color: #4fd3d0;
    }

    .icon-box.ELECTRICMETER {  /*智能电表*/
      background-color: #8ac925;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/PhonePage/Applet/ShareDevice.vue